/* RR product selection. Shopify variants are the authority for purchase and waitlist IDs. */
(function (root) {
  'use strict';
  function value(v, position) { return v['option' + position] != null ? v['option' + position] : (v.options || [])[position - 1]; }
  function matching(variants, selected, except) {
    return variants.filter(function (v) {
      return Object.keys(selected).every(function (p) { return +p === except || selected[p] == null || value(v, +p) === selected[p]; });
    });
  }
  function resolve(variants, selected, count) {
    for (var p = 1; p <= count; p++) if (selected[p] == null) return { state: 'unselected', variant: null };
    var v = matching(variants, selected)[0];
    return { state: v ? (v.available ? 'available' : 'soldout') : 'unavailable', variant: v || null };
  }
  function waitlist(variants, selected, options) {
    var sizePosition = options.findIndex(function (name) { return /size/i.test(name); }) + 1;
    return matching(variants, selected, sizePosition || undefined).filter(function (v) { return !v.available; }).map(function (v) {
      return { id: v.id, label: sizePosition ? value(v, sizePosition) : v.title, available: false };
    });
  }
  var api = { value: value, matching: matching, resolve: resolve, waitlist: waitlist };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  root.RRVariants = api;
  var document = root.document, dataEl = document.getElementById('rrProductData'), form = document.getElementById('pdpForm');
  if (!dataEl || !form) return;
  var data, variants, options, selected = {}, bras = {}, current = null, nativeMode = false;
  var idInput = document.getElementById('pdpVariantId'), atc = document.getElementById('pdpAtc'), wl = document.getElementById('pdpWaitlist');
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
  }
  function status(message) {
    var el = document.getElementById('pdpStatus');
    if (el) { el.textContent = message || ''; el.hidden = !message; }
  }
  function candidates(position, test) { return matching(variants, selected, position).filter(function (v) { return test(value(v, position)); }); }
  function buttonState(button, list, on) {
    button.classList.toggle('on', !!on);
    button.classList.toggle('soldout', !list.some(function (v) { return v.available; }));
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-disabled', list.length ? 'false' : 'true');
  }
  function repaint() {
    form.querySelectorAll('.sk-pdp-sw,.sk-pdp-size[data-value]').forEach(function (b) {
      var pos = +b.dataset.position, val = b.dataset.value;
      var list = b.classList.contains('sk-pdp-sw') ? variants.filter(function (v) { return value(v, pos) === val; }) : candidates(pos, function (x) { return x === val; });
      buttonState(b, list, selected[pos] === val);
    });
    Object.keys(bras).forEach(function (p) {
      var pos = +p, bra = bras[p];
      form.querySelectorAll('.sk-pdp-band[data-position="' + p + '"]').forEach(function (b) {
        buttonState(b, candidates(pos, function (x) { return String(x).slice(0, 2) === b.dataset.band; }), bra.band === b.dataset.band);
      });
      form.querySelectorAll('.sk-pdp-cup[data-position="' + p + '"]').forEach(function (b) {
        buttonState(b, candidates(pos, function (x) { return String(x).slice(2) === b.dataset.cup && (!bra.band || String(x).slice(0, 2) === bra.band); }), bra.cup === b.dataset.cup);
      });
    });
    var color = form.querySelector('.sk-pdp-sw.on'), colorName = document.getElementById('pdpColorName');
    if (color && colorName) colorName.textContent = color.dataset.value;
  }
  function update(changeUrl) {
    current = resolve(variants, selected, options.length);
    var v = current.variant;
    idInput.disabled = current.state !== 'available';
    idInput.value = v ? String(v.id) : '';
    atc.hidden = current.state === 'soldout';
    atc.disabled = current.state !== 'available';
    atc.classList.toggle('ready', current.state === 'available');
    atc.textContent = { unselected: 'Select an Option', unavailable: 'Unavailable', available: 'Add to Bag', soldout: 'Sold Out' }[current.state];
    if (current.state === 'unselected' && options.some(function (o) { return /size/i.test(o); })) atc.textContent = 'Select a Size';
    if (wl) wl.hidden = current.state !== 'soldout';
    if (v) {
      var price = document.getElementById('pdpPrice');
      if (price) price.textContent = money(v.price);
      var image = v.featured_image && v.featured_image.src;
      if (image && root.__pdpGoToSrc) root.__pdpGoToSrc(image);
    }
    if (changeUrl && root.history.replaceState) {
      var url = new URL(root.location.href);
      if (v) url.searchParams.set('variant', v.id); else url.searchParams.delete('variant');
      root.history.replaceState(root.history.state, '', url);
    }
    status(current.state === 'unavailable' ? 'This combination is not offered. Please choose another option.' : '');
    repaint();
  }
  function hydrate(requested) {
    selected = {};
    var explicit = variants.find(function (v) { return String(v.id) === String(requested); });
    options.forEach(function (name, i) {
      var pos = i + 1, values = Array.from(new Set(variants.map(function (v) { return value(v, pos); })));
      if (explicit) selected[pos] = value(explicit, pos);
      else if (values.length === 1) selected[pos] = values[0];
      else if (/^colou?r$/i.test(name)) {
        var b = form.querySelector('.sk-pdp-sw.on[data-position="' + pos + '"]');
        selected[pos] = b ? b.dataset.value : values[0];
      }
    });
    Object.keys(bras).forEach(function (p) {
      var s = selected[p]; bras[p] = { band: s ? s.slice(0, 2) : null, cup: s ? s.slice(2) : null };
    });
    update(false);
  }
  function fallback(error) {
    nativeMode = true;
    console.error('RR variant picker could not initialize; native selection is available.', error);
    idInput.disabled = true;
    form.querySelectorAll('.sk-pdp-opt').forEach(function (el) { el.hidden = true; });
    var fallbackEl = document.getElementById('rrVariantFallback'), select = document.getElementById('rrNativeVariant');
    fallbackEl.hidden = false; select.disabled = false; atc.hidden = true;
    if (wl) wl.hidden = true;
    status('Please use the option list to select your item.');
  }
  try {
    data = JSON.parse(dataEl.textContent); variants = data.variants; options = data.options;
    form.querySelectorAll('.sk-pdp-braopt').forEach(function (el) { bras[el.dataset.optPosition] = { band: null, cup: null }; });
    hydrate(data.selectedVariantId);
    document.getElementById('rrNativeVariant').disabled = true;
    document.getElementById('rrVariantFallback').hidden = true;
    form.addEventListener('click', function (event) {
      var b = event.target.closest('.sk-pdp-sw,.sk-pdp-size');
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      var pos = +b.dataset.position;
      if (b.dataset.band || b.dataset.cup) {
        var bra = bras[pos];
        if (b.dataset.band) {
          bra.band = b.dataset.band;
          if (bra.cup && !candidates(pos, function (x) { return x === bra.band + bra.cup; }).length) bra.cup = null;
        } else bra.cup = b.dataset.cup;
        selected[pos] = bra.band && bra.cup ? bra.band + bra.cup : null;
      } else selected[pos] = b.dataset.value;
      update(true);
      if (b.dataset.img && !current.variant && root.__pdpGoToSrc) root.__pdpGoToSrc(b.dataset.img);
    });
    form.addEventListener('submit', function (event) {
      if (nativeMode) return;
      if (!current || current.state !== 'available') { event.preventDefault(); event.stopImmediatePropagation(); status('Please select an available option before adding to your bag.'); }
    });
    if (wl) wl.addEventListener('click', function () {
      if (!current || current.state !== 'soldout' || !root.skNotifyOpen) return;
      root.skNotifyOpen({ title: document.querySelector('main h1').textContent, sizes: waitlist(variants, selected, options), selectedId: current.variant.id, optionLabel: options.some(function (o) { return /size/i.test(o); }) ? 'Size' : 'Option' });
    });
    root.addEventListener('popstate', function () { hydrate(new URL(root.location.href).searchParams.get('variant')); });
  } catch (error) { fallback(error); }
})(typeof window === 'undefined' ? null : window);
